export default __webpack_public_path__ + "static/media/work-process-1.e906b203.jpg";